const TITLE_TEXT_KEY = "drawer_title";
const ERROR_MESSAGE_TEXT_KEY = "error_message";
const BACK_BUTTON_ARIA_LABEL_TEXT_KEY = "back_button_aria_label";
const CLOSE_BUTTON_ARIA_LABEL_TEXT_KEY = "close_button_aria_label";
export {
  BACK_BUTTON_ARIA_LABEL_TEXT_KEY,
  CLOSE_BUTTON_ARIA_LABEL_TEXT_KEY,
  ERROR_MESSAGE_TEXT_KEY,
  TITLE_TEXT_KEY
};
